module.exports = __webpack_public_path__ + "img/asset-explained.2001e200.svg";